import { render } from "./Statistics.vue?vue&type=template&id=25df54ea&scoped=true&ts=true"
import script from "./Statistics.vue?vue&type=script&lang=ts"
export * from "./Statistics.vue?vue&type=script&lang=ts"

import "@/assets/scss/report-grid.scss?vue&type=style&index=0&id=25df54ea&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25df54ea"]])

export default __exports__